module.exports = __webpack_public_path__ + "static/img/course_constuct.aecbf82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/listitem/course_constuct.png
// module id = 42
// module chunks = 0